import styled from 'styled-components';
import {Detail} from '@forecast-it/design-system';

/*
 * The Import QuickBooks Configuration card in the new design: the layout of XeroConfigurationImport
 * (T4-205) token for token, plus the parts only QuickBooks has (the coloured status tone, the message
 * under a failed option, the Imported pill beside the button).
 */

export const ConfigImportDescription = styled.div`
	max-width: 1080px;
	margin-top: ${props => props.theme.sys.spacing['300']};
`;

export const ConfigImportOrganisationField = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${props => props.theme.sys.spacing['200']};
	margin-top: ${props => props.theme.sys.spacing['600']};
	width: 280px;
	max-width: 100%;
`;

export const ConfigImportRows = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${props => props.theme.sys.spacing['300']};
	margin-top: ${props => props.theme.sys.spacing['600']};
`;

/* One option: its row, then - on a failure with a known cause - the message on its own line under it. */
export const ConfigImportOption = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${props => props.theme.sys.spacing['100']};
`;

// Checkbox and label, then the status beside them. The status (Detail noWrap) never breaks inside
// itself, so a date cannot split; on a narrow window the whole status moves under the label instead.
export const ConfigImportRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	column-gap: ${props => props.theme.sys.spacing['300']};
`;

/* The status after the label: grey detail text as on Xero, red for a failure and green for a success
   (spec 032). data-tone, not a prop, so the colour is a plain attribute selector and the tests can read
   the tone off the DOM. The doubled ampersand outranks Detail's own colour. */
export const ConfigImportStatusText = styled(Detail)`
	&&[data-tone='error'] {
		color: ${props => props.theme.sys.color.text.semantic.error};
	}
	&&[data-tone='success'] {
		color: ${props => props.theme.sys.color.text.semantic.success};
	}
`;

/* The message under a failed option (spec 032, What a row shows), lined up with the label text after
   the checkbox, max 720px wide. */
export const ConfigImportMessage = styled.p`
	&& {
		margin: 0 0 0 ${props => props.theme.sys.spacing['600']};
		max-width: 720px;
		color: ${props => props.theme.sys.color.text.semantic.error};
		font-size: 12px;
		line-height: 16px;
	}
`;

export const ConfigImportActions = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: ${props => props.theme.sys.spacing['300']};
	margin-top: ${props => props.theme.sys.spacing['600']};
`;

/* The Imported pill and the button, together on the right. */
export const ConfigImportActionsEnd = styled.div`
	display: flex;
	align-items: center;
	gap: ${props => props.theme.sys.spacing['300']};
	margin-left: auto;
`;
